// material
import { Stack } from "@mui/material";

// ----------------------------------------------------------------------

export default function RoadmapContent() {
  return (
    <Stack sx={{ p: "5%" }}>
      <img src="/assets/Roadmap.png" style={{ width: "100%" }} />
    </Stack>
  );
}